export default __webpack_public_path__ + "static/003-eed1c3ab998183758941768e4faffe9e.png";